/* eslint-disable @typescript-eslint/no-unused-vars */
import formatCnpj from '../../../utils/formatCnpj';
import { AsideContainer, Container, Group } from '../styles';
import { GeneralCompanyDataType } from '../types';

interface GeneralDataCardInterface {
  generalData: GeneralCompanyDataType
  companyToken: string
}

export default function GeneralDataCard({ generalData, companyToken }: GeneralDataCardInterface) {
  return (
    <Container>
      <div className="card-title">
        Dados Gerais
      </div>
      <AsideContainer>
        <Group aside>
          <div className="title">
            CNPJ
          </div>
          <span>
            {generalData?.cnpj || 'Não informado'}
          </span>
        </Group>
        <Group aside>
          <div className="title">
            CNPJ de pagamento / NF
          </div>
          <span>
            {generalData?.cnpjPagto || generalData?.cnpj || 'Não informado'}
          </span>
        </Group>
      </AsideContainer>
      <AsideContainer>
        <Group aside>
          <div className="title">
            Nota Fiscal do CNPJ Pagador Separada?
          </div>
          <span>
            {generalData?.pagadorNFSeparada ? 'Sim' : 'Não'}
          </span>
        </Group>
        <Group aside>
          <div className="title">
            CNPJ Correto Original
          </div>
          <span>
            {generalData?.cnpjCorretoOriginal ? formatCnpj(generalData.cnpjCorretoOriginal) : 'Não informado'}
          </span>
        </Group>
      </AsideContainer>
      <AsideContainer>
        <Group aside>
          <div className="title">
            Nome Fantasia
          </div>
          <span>
            {generalData?.fantasyName || 'Não informado'}
          </span>
        </Group>
      </AsideContainer>
      <AsideContainer>
        <Group aside>
          <div className="title">
            Razão Social
          </div>
          <span>
            {generalData?.companyName || 'Não informado'}
          </span>
        </Group>
        <Group aside>
          <div className="title">
            Quantidade de funcionários
          </div>
          <span>
            {generalData?.employeesQty || 'Não informado'}
          </span>
        </Group>
      </AsideContainer>
      <Group>
        <div className="title">
          Telefone
        </div>
        <span>
          {generalData?.companyPhone || 'Não informado'}
        </span>
      </Group>
      <AsideContainer>
        <Group aside>
          <div className="title">
            Inscrição estadual
          </div>
          <span>
            {generalData?.stateRegistration || 'Não informado'}
          </span>
        </Group>
        <Group aside>
          <div className="title">
            Inscrição municipal
          </div>
          <span>
            {generalData?.municipalRegistration || 'Não informado'}
          </span>
        </Group>
      </AsideContainer>
      <AsideContainer>
        <Group aside>
          <div className="title">
            Acesso My-Link
          </div>
          <span>
            {`${process.env.REACT_APP_MYLINK_BASE_URL}?codEmpresa=${generalData?.companyCode}` || 'Não informado'}
          </span>
        </Group>
        <Group aside>
          <div className="title">
            Acesso Recadastramento de VT
          </div>
          <span>
            {`${process.env.REACT_APP_MYLINK_BASE_URL}?codEmpresa=${generalData?.companyCode}&isVtRegistration` || 'Não informado'}
          </span>
        </Group>
      </AsideContainer>
      <AsideContainer>
        <Group aside>
          <div className="title">
          Token Integração Webhook
          </div>
          <span style={{ wordBreak: 'break-all' }}>
            {companyToken || 'Token indisponível (para ter um token, a empresa precisa ter um parceiro com os webhooks configurados)'}
          </span>
        </Group>
      </AsideContainer>
    </Container>
  );
}
